import gql from 'graphql-tag';

export const occupationFragments = gql`
  fragment occupationFragments on Occupation {
    id
    name
    code
    validFrom
  }
`;

export const occupationSelectionFragments = gql`
  fragment occupationSelectionFragments on OccupationSelection {
    id
    occupation {
      ...occupationFragments
    }
  },
  ${occupationFragments}
`;

export const ALL_OCCUPATIONS = gql`
  query occupations {
    currentUnit {
      id
      occupations {
        ...occupationFragments
      }
    }
  },
  ${occupationFragments}
`;
